import type { GlobalOnexConfig, OnexConfig } from '@otto-ec/eprivacy-onex'
import { BroadcastPort, CmpImpl, FeatureTogglePort, LoggingPort } from './ports'
import {
  ActiveOnexConfigAdapter,
  BroadcastAdapter,
  CmpAdapter,
  environmentConfigAdapter,
  featureTogglesAssetsAdapter,
  isApp,
  onexAssignmentsAdapter,
} from './adapters'
import {
  createLoggingService,
  createMeasureServiceFor,
  MeasureType,
} from '@otto-ec/eprivacy-measures'

export { retryIterativeStrategy, type RetryStrategy } from './utils'

export const TEAM = 'eprivacy'
export const SERVICE = 'consent-banner'

export const initMeasureService = createMeasureServiceFor(
  MeasureType.Init,
  TEAM,
  SERVICE
)

export const logger: LoggingPort = createLoggingService(TEAM, SERVICE)

export const broadcaster: BroadcastPort = new BroadcastAdapter()

export const environmentConfig = environmentConfigAdapter()
export const featureToggles: FeatureTogglePort = featureTogglesAssetsAdapter
export const cmp: CmpImpl = new CmpAdapter().cmp()

export const IS_APP = isApp()

export async function activeVariantConfig(): Promise<OnexConfig> {
  const activeOnex = new ActiveOnexConfigAdapter(
    logger,
    onexAssignmentsAdapter,
    await loadOnexConfig()
  )
  return activeOnex.activeOnexConfig()
}

async function loadOnexConfig(): Promise<GlobalOnexConfig> {
  return (
    environmentConfig.stage === 'live'
      ? await import('../../../onex-config')
      : await import('../../../onex-config.nonlive')
  ).config
}
